import { CellEditorSelectorResult, ColDef, ICellEditorParams, ICellRendererParams } from "ag-grid-community";
import { IFormGrid, IFormGridColumn } from "../../../services/custom-forms-data-service/TemplateModels";
import { FormValueDataType, IFormInstanceData, IFormInstanceValue } from "../../../views/object-form-view/Models";
import { RowDef } from "../../ag-grid-extensions/models/RowDef";
import { CustomFormRunnerModeType } from "../CustomFormRunner";
import CustomFormRunnerUtils from "../CustomFormRunnerUtils";

const createRow = (data: IFormGridColumn[], 
    index: number, 
    rowData: IFormInstanceValue<FormValueDataType>[] | undefined) : RowDef => {

    let row: RowDef = {
        id: `row:${index}`,
        data: data
    };

    data.forEach(o => {
        const value = rowData?.find(v => v.name === o.field)?.value;


        if (o.controlType === 'select' && o.options) {
            let option: string | undefined;

            if (o.valueType === 'boolean') {
                option = o.options.find(v => v.value as boolean === value as boolean)?.name;
            } else if (o.valueType === 'string') {
                option = o.options.find(v => v.value as string === value as string)?.name;
            }
            row[o.field] = option ?? value ?? o.defaultValue ?? '';
        } else if (o.controlType === 'checkbox') {
            row[o.field] = value as boolean ?? o.defaultValue as boolean ?? false;
        } else {
            row[o.field] = value ?? o.defaultValue ?? '';
        }
    });

    return row;
}

const createColumn = (col: IFormGridColumn, mode: CustomFormRunnerModeType | undefined): ColDef => {

    return {
        headerName: col.headerName,
        field: col.field,
        editable: mode === 'view' || col.controlType === 'checkbox' ? false : col.editable,
        singleClickEdit: true,
        flex: col.flex ?? 1,
        cellRenderer: col.controlType === 'checkbox' ? 'checkBoxCellRenderer' : undefined,
        cellRendererParams: col.controlType === 'checkbox' ? (params: ICellRendererParams | ICellEditorParams) => {
            return {...params,
            disabled: mode === 'view'}
        } : undefined,
        cellEditorSelector:  (params: ICellRendererParams | ICellEditorParams): CellEditorSelectorResult | undefined => {

            const columns: IFormGridColumn[] = params.data?.data;
            const item = columns?.find(o => o.field === params.colDef?.field);

            switch (item?.controlType) {
                case 'textfield':
                    return item.valueType === 'number' ? { 
                        component: 'numericCellEditor'
                    } : 
                    undefined;

                case 'checkbox':
                    return undefined;

                case 'select':
                    return {
                        component: 'agRichSelectCellEditor',
                        popup: true,
                        params: {
                            values: item.options?.map(o => {
                                return o.name;
                            })
                        }
                    }
            }
        },
        cellEditorParams: (params: ICellEditorParams) => {
            return params;
            // const tag: IEntityValueTagModel = params.data?.tag;
            // const features: ObjectFeaturesEnum = tag.features as ObjectFeaturesEnum;

            // if (!tag.listID && (features & ObjectFeaturesEnum.FeetAndInches) === 0) {
            //     const cellEditorParams: INumericCellEditorParams = {
            //         ...params,
            //         decimals: tag.decimalPlaces,
            //         lowerBound: tag.writeLowerBound,
            //         lowerBoundOp: tag.writeLowerBoundOp,
            //         upperBound: tag.writeUpperBound,
            //         upperBoundOp: tag.writeUpperBoundOp
            //     };
            //     return cellEditorParams;
            // } else {
            //     return params;
            // }
        },


    } as ColDef;
}

const CustomFormGridUtils = {


    createColumns: (grid: IFormGrid, mode: CustomFormRunnerModeType | undefined): ColDef[] => {
        return grid.columns.map(o => createColumn(o, mode));
    },
    
    createRows: (grid: IFormGrid, instanceData: IFormInstanceData | undefined): RowDef[] => {
    
        const history = CustomFormRunnerUtils.getLatestHistory(instanceData);
        const rowData = history?.values.find(o => o.name === grid.name)?.value as Array<IFormInstanceValue<FormValueDataType>[]> | undefined;                            
        const rows: RowDef[] = [];
        //IFormInstanceValue<FormValueDataType>[]
        const rowCount = grid.defaultRowCount ?? 10;
        for (let i = 0; i < rowCount; ++i) {

            const row = rowData && i < rowData.length ? rowData[i] : undefined;
            rows.push(createRow(grid.columns, i, row));
        }

        return rows;
    }

    
};

export default CustomFormGridUtils;